import { call, put, select, takeEvery } from 'redux-saga/effects';
import { captureException } from '@sentry/nextjs';
import { selectMatchedStrategyCollection } from '../../../../Helpers/strategyCollection.helpers';
import { selectCurrentStepKey } from '../../../../Helpers/clientApiJourneyPosition.helpers';
import ActionTypes from '../../../../Data/ActionTypes';
import FetchStatus from '../../../../Data/FetchStatus';
import { incrementMetric } from '../../../../Services/Datadog';
import { getErrorTypeTag } from '../clientApiError.helpers';
import { getStepApi } from '../clientApiStep.helpers';
import { resolveDependencies } from '../clientApiDependencies.helpers';
import {
  setSolarLoadStatus,
  setStepResponse,
} from '../../slices/clientApiJourney';
import { fetchClientApiSolar } from './fetchClientApiSolar';

export function* getClientApiSolarWorker() {
  try {
    yield put(setSolarLoadStatus({ solarLoadStatus: FetchStatus.IN_PROGRESS }));

    const matchedCollection = yield select(selectMatchedStrategyCollection);
    const stepKey = yield select(selectCurrentStepKey);
    const api = getStepApi({
      collection: matchedCollection,
      stepKey,
      operation: 'load',
    });

    if (!api?.url) {
      throw new Error(`No load operation on strategy step ${stepKey}`);
    }

    const submissionId = yield select((state) => state.submission?.id);
    const token = yield select((state) => state.submission?.token);
    const stepStates = yield select(
      (state) => state.clientApiJourney.stepStates
    );
    const stepResponses = yield select(
      (state) => state.clientApiJourney.stepResponses
    );
    const locationOverride = yield select(
      (state) => state.clientApiJourney.solar?.locationOverride
    );

    const body = resolveDependencies({
      dependencies: api.dependencies,
      ownKey: stepKey,
      ownInputs: locationOverride ? { locationOverride } : {},
      stepStates,
      stepResponses,
    });

    const response = yield call(fetchClientApiSolar, {
      api,
      body,
      submissionId,
      token,
    });

    yield put(setStepResponse({ stepKey, operation: 'load', response }));
    yield put(setSolarLoadStatus({ solarLoadStatus: FetchStatus.COMPLETED }));
  } catch (error) {
    incrementMetric({
      name: 'getClientApiSolarError',
      tags: { type: getErrorTypeTag(error) },
    });
    captureException(error);
    yield put(setSolarLoadStatus({ solarLoadStatus: FetchStatus.FAILED }));
  }
}

export default function* getClientApiSolarSaga() {
  yield takeEvery(ActionTypes.GET_CLIENT_API_SOLAR, getClientApiSolarWorker);
}
